<div class="round-progress" 
  [class.is-small]="small"
  [class.is-avatar]="isAvatar"
  [class.is-ultra-small]="ultraSmall"
  [class.is-blue]="scoreValue >= 50 && scoreValue < 75"
  [class.is-green]="scoreValue >= 75"
  [class.is-thin]="thin"
  [attr.data-progress]="scoreValue + '%'"
  style="--progress: {{ scoreValue }}%">
</div>
<span *ngIf="ultraSmall">{{ scoreValue }}%</span>